import GridCheckbox from "../components/GridCheckbox";

export const createDynamicColumnsFromObject = (object: any) => {
	if (!object) {
		return [];
	}
	return Object.entries(object).map(([key, value], index) =>
		typeof value == "boolean"
			? {
					field: key,
					cellRendererSelector: (params: any) => ({
						component: GridCheckbox,
						params: { value: params.data[key] },
					}),
			  }
			: {
					field: key,
			  }
	);
};
